"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeCreativeFastStart = void 0;
const CreativeFastStart_1 = require("../entity/CreativeFastStart");
const createSomeCreativeFastStart = ({ enabled = true, } = {}) => new CreativeFastStart_1.default({ enabled });
exports.createSomeCreativeFastStart = createSomeCreativeFastStart;
